import { useMediaQuery } from '@intigral/hooks';
import { useSelector } from 'react-redux';
import { IStore } from '../../../interfaces/StoreTypes';
import useProfileAvatars from '../../../hooks/useProfileAvatars';
import { useProfileList } from '../../../utils/useUserProfile';
import { getUserInfo } from '../../../utils/user';
import { __ } from '../../../translations';
import { useNavigate } from 'react-router-dom';
import { parentalPinManagementConstants, screenDetailTypes, STORE_NAME } from '../../../config/constants';
import url from '../../../helpers/url';
import { useLogout } from '../hooks/useLogout';
import useLanguage from '../../../hooks/useLanguage';
import { useProfileExit } from '../../../hooks/useProfileExit';
import { isGuestUser } from '../../../config/guestMode';
import { setGuestKidsMode } from '../../../guest/session';

export const useHeaderMenuActions = () => {
    const { selectedProfile } = useSelector((state: IStore) => state.profile);
    const navigate = useNavigate();
    const { logoutUser } = useLogout();
    const { data: avatarData } = useProfileAvatars();
    const { data: profileList } = useProfileList(getUserInfo());
    const isMobile = useMediaQuery('(max-width: 924px)');
    const language = useLanguage();
    const selectProfileUrl = language === 'en' ? '/en/select-profile' : '/select-profile';
    const accountUrl = language === 'en' ? '/en/account' : '/ar/account';
    const profileSettingUrl = language === 'en' ? '/en/profile-settings' : '/profile-settings';
    const kidExitUrl = url.route(
        url.getDetailsPage(parentalPinManagementConstants.PARENTAL_PIN) + window.btoa('kid-exit|validate')
    );
    const { exitKidsMode } = useProfileExit();

    const handleKidExit = (e: { preventDefault?: () => void }) => {
        if (isGuestUser(getUserInfo())) {
            e.preventDefault?.();
            setGuestKidsMode(false);
            navigate(url.route(''), { replace: true });
            return;
        }

        e.preventDefault?.();
        exitKidsMode();
    };

    const handleLogOutUser = (e) => {
        e.preventDefault();
        logoutUser();
    };

    const handleManage = () => {
        document.body.classList.remove('nav-visible');
        navigate(url.route(url.getDetailsPage(screenDetailTypes.PROFILE_SELECT)));
    };

    return {
        isMobile,
        selectedProfile,
        avatarData,
        profileList,
        selectProfileUrl,
        accountUrl,
        profileSettingUrl,
        kidExitUrl,
        language,
        handleLogOutUser,
        handleManage,
        handleKidExit,
    };
};
